import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import createReactContext from '../context';
import { deepGet } from '../utils/objects';
import { isObject, isArray } from '../utils/is';
import { curry3 } from '../utils/func'; // 去掉独有的属性

var context = createReactContext({}); // eslint-disable-next-line

export var Provider = context.Provider; // eslint-disable-next-line

export var Consumer = context.Consumer;
export var formProvider = function formProvider(Origin) {
  var FormProvider =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(FormProvider, _PureComponent);

    var _super = _createSuper2(FormProvider);

    function FormProvider(props) {
      var _this;

      _classCallCheck(this, FormProvider);

      _this = _super.call(this, props);
      _this.combineRules = _this.combineRules.bind(_assertThisInitialized(_this)); // this.groupValidate = this.groupValidate.bind(this)

      return _this;
    }

    _createClass(FormProvider, [{
      key: "combineRules",
      value: function combineRules(name, propRules) {
        var rules = this.props.rules;
        var newRules = [];

        if (isObject(rules) && name) {
          newRules = deepGet(rules, name) || [];
        } else if (isArray(rules)) {
          newRules = rules;
        }

        if (isArray(propRules)) {
          newRules = newRules.concat(propRules);
        }

        return newRules;
      } // groupValidate(name) {
      // not implement...
      // }

    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            datum = _this$props.datum,
            labelAlign = _this$props.labelAlign,
            labelVerticalAlign = _this$props.labelVerticalAlign,
            labelWidth = _this$props.labelWidth,
            disabled = _this$props.disabled,
            pending = _this$props.pending,
            mode = _this$props.mode,
            size = _this$props.size,
            keepErrorHeight = _this$props.keepErrorHeight;
        var value = {
          formDatum: datum,
          formMode: mode,
          disabled: !!(disabled || pending),
          labelAlign: labelAlign,
          labelVerticalAlign: labelVerticalAlign,
          labelWidth: labelWidth,
          size: size,
          combineRules: this.combineRules,
          // groupValidate: this.groupValidate,
          keepErrorHeight: keepErrorHeight
        };
        return (
          /*#__PURE__*/
          React.createElement(Provider, {
            value: value
          },
          /*#__PURE__*/
          React.createElement(Origin, this.props))
        );
      }
    }]);

    return FormProvider;
  }(PureComponent);

  return FormProvider;
};
export var formConsumer = curry3(function (keys, Origin, props) {
  var filterProps = function filterProps(value) {
    var cps = {};
    if (!value) return cps;
    if (!keys) return value;
    keys.forEach(function (k) {
      var val = value[k];
      if (val !== undefined) cps[k] = val;
    });
    return cps;
  };

  return (
    /*#__PURE__*/
    React.createElement(Consumer, null, function (value) {
      var formProps = filterProps(value);
      return (
        /*#__PURE__*/
        React.createElement(Origin, Object.assign({}, formProps, props, {
          disabled: formProps.disabled || props.disabled
        }))
      );
    })
  );
});